<!--
 * @Descripttion: 拖拽组件：支持位置可拖拽、宽度、高度可变的
 * @Author: zenghua.wang
 * @Date: 2021-05-19 17:46:41
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-10 10:55:10
-->
<template>
  <div
    :class="
      setClass({
        active: (active || overActive) && !readonly,
        move: moveActive,
        click: disabled,
      })
    "
    @mousedown.stop="handleMove"
    @mouseover.stop="handleOver"
    @mouseout.stop="handleOut"
    :style="styleName"
  >
    <el-input
      ref="myinput"
      :class="setClass('focus')"
      v-model="value"
    />

    <div
      :class="setClass('wrapper')"
      ref="wrapper"
    >
      <template v-if="(active || overActive || moveActive) && !readonly">
        <div
          :style="styleLineName"
          :class="setClass('line', ['left'])"
        ></div>
        <div
          :style="styleLineName"
          :class="setClass('line', ['top'])"
        ></div>
        <div
          :class="setClass('line', ['label'])"
          :style="styleLabelName"
        >
          {{ baseLeft }},{{ baseTop }}
        </div>
      </template>

      <template v-if="!readonly">
        <template v-for="(item, index) in pointList">
          <div
            :class="setClass('point', [item.classname])"
            :key="index"
            v-if="active"
            :style="[stylePointName, getPointStyle(item.classname)]"
            @mousedown.stop="pointMove($event, item.classname)"
          ></div>
        </template>
      </template>

      <!-- <div
        :class="setClass('menu')"
        :style="styleMenuName"
        v-show="active || overActive"
      >
        <slot name="menu" :zIndex="zIndex" :index="index"></slot>
      </div> -->

      <div
        :class="setClass('item')"
        ref="item"
      >
        <slot></slot>
      </div>

      <div
        :class="setClass('mask')"
        v-if="!disabled && mask"
      ></div>
    </div>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { getFixed, setPx } from '@/dragComponents/utils'
export default {
  name: 'drag-position',
  mixins: [bem],
  props: {
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    zIndex: {
      type: [Number, String],
      default: 1
    },
    index: {
      type: [String, Number]
    },
    mask: {
      type: Boolean,
      default: true
    },
    scale: {
      type: Number,
      default: 1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    resize: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    focus: {
      type: Function,
      default: () => {}
    },
    blur: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      value: '',
      baseWidth: 0,
      baseHeight: 0,
      baseLeft: 0,
      baseTop: 0,
      children: {},
      moveActive: false,
      overActive: false,
      pointActive: false,
      active: false,
      keyDown: null,
      pointList: [
        {
          classname: 'left'
        },
        {
          classname: 'right'
        },
        {
          classname: 'top'
        },
        {
          classname: 'bottom'
        },
        {
          classname: 'top-left'
        },
        {
          classname: 'top-right'
        },
        {
          classname: 'bottom-left'
        },
        {
          classname: 'bottom-right'
        }
      ]
    }
  },
  computed: {
    scaleVal() {
      return this.scale
    },
    styleMenuName() {
      return {
        transformOrigin: '0 0',
        transform: `scale(${this.scaleVal})`
      }
    },
    styleLineName() {
      return {
        borderWidth: setPx(this.scaleVal)
      }
    },
    stylePointName() {
      const calc = 10 * this.scaleVal
      return {
        width: setPx(calc),
        height: setPx(calc)
      }
    },
    styleLabelName() {
      return {
        fontSize: setPx(18 * this.scaleVal)
      }
    },
    styleName() {
      return Object.assign(
        (() => {
          if (this.active) {
            return Object.assign(
              {
                zIndex: 9999
              },
              this.styleLineName
            )
          }
          return { zIndex: this.zIndex }
        })(),
        {
          top: setPx(this.baseTop),
          left: setPx(this.baseLeft),
          width: setPx(this.baseWidth),
          height: setPx(this.baseHeight)
        }
      )
    }
  },
  watch: {
    active(val) {
      if (val) {
        this.handleKeydown()
      } else {
        document.onkeydown = this.keyDown
      }
    },
    width(val) {
      this.baseWidth = getFixed(val) || this.children.offsetWidth
    },
    height(val) {
      this.baseHeight = getFixed(val) || this.children.offsetHeight
    },
    left(val) {
      this.baseLeft = getFixed(val)
    },
    top(val) {
      this.baseTop = getFixed(val)
    },
    baseWidth(val) {
      this.$refs.wrapper.style.width = setPx(val)
      if (this.resize && this.children.style) {
        this.children.style.width = setPx(val)
      }
    },
    baseHeight(val) {
      this.$refs.wrapper.style.height = setPx(val)
      if (this.resize && this.children.style) {
        this.children.style.height = setPx(val)
      }
    }
  },
  methods: {
    init() {
      this.children = this.$refs.item.firstChild
      this.baseWidth = getFixed(this.width) || this.children.offsetWidth
      this.baseHeight = getFixed(this.height) || this.children.offsetHeight
      this.baseLeft = getFixed(this.left)
      this.baseTop = getFixed(this.top)
      this.keyDown = document.onkeydown
    },
    setLeft(left) {
      this.baseLeft = left
    },
    setTop(top) {
      this.baseTop = top
    },
    getPointStyle(postion) {
      const calc = (10 * this.scaleVal) / 2
      let result = {}
      let list = postion.split('-')
      list.forEach(ele => {
        result[ele] = setPx(-calc)
      })
      return result
    },
    setOverActive(val) {
      this.overActive = val
    },
    setActive(val) {
      this.active = val
    },
    pointMove(e, pos) {
      if (this.disabled) return
      // 移动的方向
      let x, y
      // 移动的位置
      let xp, yp
      // 移动的正负
      let xc, yc
      this.pointActive = true
      this.handleMouseDown()
      let disX = e.clientX
      let disY = e.clientY
      document.onmousemove = e => {
        this.moveActive = true
        if (pos === 'right') {
          x = true
          y = false
        } else if (pos === 'left') {
          x = true
          xp = true
          xc = true
          y = false
        } else if (pos === 'top') {
          x = false
          y = true
          yp = true
          yc = true
        } else if (pos === 'bottom') {
          x = false
          y = true
        } else if (pos === 'bottom-right') {
          x = true
          y = true
        } else if (pos === 'bottom-left') {
          x = true
          y = true
          xp = true
          xc = true
        } else if (pos === 'top-right') {
          x = true
          y = true
          yp = true
          yc = true
        } else if (pos === 'top-left') {
          x = true
          y = true
          xp = true
          xc = true
          yp = true
          yc = true
        }
        let left = e.clientX - disX
        let top = e.clientY - disY
        disX = e.clientX
        disY = e.clientY
        if (x) {
          let calc = left * this.step
          if (xc) calc = -calc
          if (xp) this.baseLeft = getFixed(this.baseLeft - calc)
          this.baseWidth = getFixed(this.baseWidth + calc)
        }
        if (y) {
          let calc = top * this.step
          if (yc) calc = -calc
          if (yp) this.baseTop = getFixed(this.baseTop - calc)
          this.baseHeight = getFixed(this.baseHeight + calc)
        }
      }
      this.handleClear()
    },
    handleOut() {
      this.overActive = false
      this.$emit('out', {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop,
        index: this.index
      })
    },
    handleOver() {
      if (this.disabled) return
      this.overActive = true
      this.$emit('over', {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop,
        index: this.index
      })
    },
    handleMove(e) {
      if (this.disabled) return
      setTimeout(() => {
        this.$refs.myinput.focus()
      })
      this.active = true
      this.handleMouseDown()
      let disX = e.clientX
      let disY = e.clientY
      document.onmousemove = e => {
        let left = e.clientX - disX
        let top = e.clientY - disY
        disX = e.clientX
        disY = e.clientY
        this.baseLeft = getFixed(this.baseLeft + left * this.step)
        this.baseTop = getFixed(this.baseTop + top * this.step)
      }
      this.handleClear()
    },
    handleClear() {
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
        this.handleMouseUp()
      }
    },
    handleKeydown() {
      document.onkeydown = event => {
        // eslint-disable-next-line no-caller
        var e = event || window.event || arguments.callee.caller.arguments[0]
        let step = 1 * this.step
        if (!this.$refs.myinput) return
        if (this.$refs.myinput.focused) {
          if (e && e.keyCode === 37) {
            this.baseLeft = getFixed(this.baseLeft - step)
          } else if (e && e.keyCode === 38) {
            this.baseTop = getFixed(this.baseTop - step)
          } else if (e && e.keyCode === 39) {
            this.baseLeft = getFixed(this.baseLeft + step)
          } else if (e && e.keyCode === 40) {
            this.baseTop = getFixed(this.baseTop + step)
          }
          event.stopPropagation()
          event.preventDefault()
          this.$emit('blur', {
            width: this.baseWidth,
            height: this.baseHeight,
            left: this.baseLeft,
            top: this.baseTop,
            index: this.index
          })
          this.keyDown && this.keyDown(event)
        }
      }
    },
    handleMouseDown(e) {
      this.moveActive = true
      this.$emit('focus', {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop,
        index: this.index
      })
    },
    handleMouseUp() {
      this.moveActive = false
      this.pointActive = false
      this.$emit('blur', {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop,
        index: this.index
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
$activeColor: rgba(115, 170, 229, 0.5);
$calcHeight: -6px;

.drag-position {
  // padding: 10px;
  position: absolute;
  cursor: move;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &-focus {
    opacity: 0;
    position: absolute !important;
    top: 0;
    left: 0;
    z-index: -1000;
  }

  &-mask {
    width: 100%;
    height: 100%;
    border: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  &__active {
    cursor: move;
    border: 1px dashed #09f;
    background-color: $activeColor;
  }

  &__move {
    opacity: 0.6;
    background-color: $activeColor;
  }

  &__click {
    cursor: pointer;
  }

  &-line {
    &__left {
      position: absolute;
      border-top: 1px dashed #09f;
      width: 10000px;
      height: 0;
      top: 0;
      transform: translateX(-100%);
    }

    &__top {
      position: absolute;
      border-left: 1px dashed #09f;
      width: 0;
      height: 10000px;
      left: 0;
      transform: translateY(-100%);
    }

    &__label {
      top: -5px;
      left: -8px;
      position: absolute;
      padding: 5px;
      transform: translate(-100%, -100%);
      color: #09f;
      font-size: 18px;
      white-space: nowrap;
      cursor: move;
    }
  }

  &-menu {
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: #409eff;
    font-size: 25px;
    color: #fff;
    z-index: 9999;
    cursor: pointer;
  }

  &-point {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    z-index: 9999;
    background-color: #09f;

    &__left,
    &__right {
      &:hover {
        cursor: ew-resize;
      }
      top: 50%;
      transform: translateY(-50%);
    }

    &__left {
      left: $calcHeight;
    }

    &__right {
      right: $calcHeight;
    }

    &__top,
    &__bottom {
      &:hover {
        cursor: ns-resize;
      }
      left: 50%;
      transform: translateX(-50%);
    }

    &__top {
      top: $calcHeight;
    }

    &__bottom {
      bottom: $calcHeight;
    }

    &__bottom-right,
    &__top-left {
      &:hover {
        cursor: nwse-resize;
      }
    }

    &__bottom-left,
    &__top-right {
      &:hover {
        cursor: nesw-resize;
      }
    }

    &__top-right {
      top: $calcHeight;
      right: $calcHeight;
    }

    &__top-left {
      top: $calcHeight;
      left: $calcHeight;
    }

    &__bottom-right {
      bottom: $calcHeight;
      right: $calcHeight;
    }

    &__bottom-left {
      bottom: $calcHeight;
      left: $calcHeight;
    }
  }
}
</style>
